import { EXPERIMENT_ID_PREFIXES } from 'chimera/all/constants/experiments'
import { EventBus } from 'chimera/all/plugins/eventbus'

const EXPERIMENT_ID_PATTERN = new RegExp(
  `^(?:${EXPERIMENT_ID_PREFIXES.join('|')})-\\S+`,
  'i',
)

/**
 * @param {object} experiment
 */
export function addExperimentVariantClassToBody(experiment) {
  const experimentCode = experiment?.id?.match(EXPERIMENT_ID_PATTERN)?.[0]
  if (!experimentCode) {
    return
  }

  const isControl = experiment.variant === 0
  const variantSuffix = isControl ? 'control' : `variant-${experiment.variant}`

  if (!isControl) {
    document.body.classList.add(`${experimentCode}__variant`)
  }

  document.body.classList.add(`${experimentCode}__${variantSuffix}`)
}

export default () => {
  /**
   * Add the experiment result as a class to the body.
   */
  EventBus.onExperimentSetEvent(({ experiment }) => {
    addExperimentVariantClassToBody(experiment)
  })
}
